import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Drag = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M9,5 L11,5 L11,7 L9,7 L9,5 Z M9,9 L11,9 L11,11 L9,11 L9,9 Z M9,13 L11,13 L11,15 L9,15 L9,13 Z M9,17 L11,17 L11,19 L9,19 L9,17 Z M13,5 L15,5 L15,7 L13,7 L13,5 Z M13,9 L15,9 L15,11 L13,11 L13,9 Z M13,13 L15,13 L15,15 L13,15 L13,13 Z M13,17 L15,17 L15,19 L13,19 L13,17 Z"
        />
    </StarryUIIcon>
);
